module.exports = __webpack_public_path__ + "img/icon-security.6d768923.png";